import { Col, Form, Row } from "antd";
import { InputCalendarioRange } from "components/input/InputCalendarioRange";
import { RelatorioFilterProdutorTransportador } from "pages/relatorios/components/RelatorioFilterProdutorTransportador";
import { SelectCidade } from "components/select/SelectCidade";
import { SelectFinanceiroBanco } from "components/select/SelectFinanceiroBanco";
import { SelectRota } from "components/select/SelectRota";
import { SelectUf } from "components/select/SelectUf";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";

export function FilterBar() {
	const filter = useRelatorioStore((s) => s.filter);

	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();
	const filterEstadoWath = Form.useWatch("filterEstado", formFiltroAvancado);

	return (
		<Form layout="vertical" form={formFiltroAvancado}>
			<Row gutter={[10, 10]}>
				<RelatorioFilterProdutorTransportador showProdutor={true} showTransportador={true} />

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterData" label="Data">
						<InputCalendarioRange
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterData: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterRotaIdpk" label="Rota">
						<SelectRota
							onChange={(_, rota) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterRota: rota,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterEstado" label="Estado">
						<SelectUf
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterEstado: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterCidade" label="Cidade">
						<SelectCidade
							uf={filterEstadoWath}
							onChange={(_, cidade) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterCidade: cidade,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterBancoIdpk" label="Banco">
						<SelectFinanceiroBanco
							onChange={(idpk) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterBancoIdpk: idpk || 0,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
